/**
 * The store's display currency, read from the tenant config the BFF resolved.
 * Every amount the SPA renders is integer US cents formatted through it; the
 * balance endpoint's own `currency` is for SDK tenants and is ignored here, so
 * there is one source and it is loaded before anything renders.
 */
import type { Currency } from "@loot-os/api-contract";

import { useTenant } from "./tenant.js";

export function useCurrency(): Currency {
  return useTenant().config.currency;
}
